export const ATTACHED_COMPANIES_LOCAL_STORAGE_KEY = 'PTPermission';
